import type { AllRouteEndpoints } from "../routeTypes";

// Stopping or resuming flips the PyMS DAG usecase flag that drives the status field on
// both the details page and the agents-list digest, so all three reads need to refetch.
// Shared by the stop and resume endpoints so the two invalidation lists cannot drift.
export const decisioningStudioAgentsStopResumeCacheKeys: AllRouteEndpoints[] = [
  "/offerfit/:app_group_id/use_cases/:use_case_id",
  "/offerfit/:app_group_id/use_cases",
  "/decisioning_studio_agents/:app_group_id",
];
